module.exports = __webpack_public_path__ + "img/four.0e79f752.png";